import React from 'react';

// Grid tiles load the small copies in public/gallery/thumbs; the lightbox uses the full-size src.
const thumbnail = (src) => src.replace('gallery/', 'gallery/thumbs/');

const Gallery = ({ images, onClick }) => {
  return (
    <div className="grid grid-cols-2 gap-2 sm:gap-3 md:grid-cols-3 lg:grid-cols-4">
      {images.map((image, index) => (
        <button
          key={image.src}
          type="button"
          onClick={() => onClick(index, image)}
          className="group aspect-[4/5] overflow-hidden bg-neutral-100"
        >
          <img
            src={thumbnail(image.src)}
            alt={image.alt || ''}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        </button>
      ))}
    </div>
  );
};

export default Gallery;
